import { render, staticRenderFns } from "./disabledWithdrawalPopup.vue?vue&type=template&id=1ed47962&scoped=true"
import script from "./disabledWithdrawalPopup.vue?vue&type=script&lang=js"
export * from "./disabledWithdrawalPopup.vue?vue&type=script&lang=js"
import style0 from "./disabledWithdrawalPopup.vue?vue&type=style&index=0&id=1ed47962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed47962",
  null
  
)

export default component.exports